export enum WorkdayStretchType {
    EXCLUDE_HOLIDAYS = 'exclude-holidays',
    INCLUDE_HOLIDAYS = 'include-holidays',
}